module.exports = __webpack_public_path__ + "static/media/final_logo_white.8266ea43.svg";